import { getId, jobLongShort, rem } from "./util";
import { updateUse } from "./svgloader";
import { updateDetail, getPrevDetailX, getPrevDetailY } from "./preview";
import { updateJobText, findJobByName } from "./jobs";

let cardJob1 = getId("cardJob1");
let cardJob2 = getId("cardJob2");
let cardJob3 = getId("cardJob3");

let jobSelected = [];

export function updateJobSelect(selectedJobs) {
  let jobNewest = selectedJobs[selectedJobs.length - 1];
  let prevCount = jobSelected.length;
  let querySelector = `:is(${selectedJobs.map(job => (`[id^=${job}]`)).join(", ")})`;
  jobSelected = document.querySelectorAll(querySelector);

  triageGenerate();

  //dynamic scaling
  if (jobSelected.length <= 5) {
    getId("adjustStyle").sheet.cssRules[13].style.width = "8rem";
    getId("adjustStyle").sheet.cssRules[14].style.width = "8rem";
    getId("adjustStyle").sheet.cssRules[14].style.borderWidth = "0.45rem";
    getId("adjustStyle").sheet.cssRules[14].style.borderRadius = "1.5rem";
    //norole
    getId("adjustStyle").sheet.cssRules[15].style.removeProperty('border');
  } else {
    //6-31
    getId("adjustStyle").sheet.cssRules[13].style.width =
      Math.map(jobSelected.length, 5, 31, 8, 3, true) + "rem";
    getId("adjustStyle").sheet.cssRules[14].style.width =
      Math.map(jobSelected.length, 5, 31, 8, 3, true) + "rem";
    getId("adjustStyle").sheet.cssRules[14].style.borderWidth =
      Math.map(jobSelected.length, 5, 31, 0.45, 0.125, true) + "rem";
    getId("adjustStyle").sheet.cssRules[14].style.borderRadius =
      Math.map(jobSelected.length, 5, 31, 1.5, 0.5, true) + "rem";
    //norole
    getId("adjustStyle").sheet.cssRules[15].style.borderWidth = "0px";
  }

  switchJobDisplay(1);

  //update bounds detail
  updateDetail(getPrevDetailX(), getPrevDetailY());
}

export function switchJobDisplay(disp) {
  if (disp == 0) {
    cardJob1.style.display = "flex";
    cardJob2.style.display = "none";
    cardJob3.style.display = "none";
  }
  if (disp == 1) {
    // query the number of selected jobs first
    if (jobSelected.length <= 1) {
      console.log("1 or less");
      cardJob1.style.display = "none";
      cardJob2.style.display = "flex";
      cardJob3.style.display = "none";
    } else {
      console.log("more than 1");
      cardJob1.style.display = "none";
      cardJob2.style.display = "none";
      cardJob3.style.display = "flex";
    }
  }
  updateDetail(getPrevDetailX(), getPrevDetailY());
}

function triageGenerate() {
  while (cardJob2.firstChild) {
    cardJob2.removeChild(cardJob2.lastChild);
  }
  while (cardJob3.firstChild) {
    cardJob3.removeChild(cardJob3.lastChild);
  }
  // idk
  jobSelected.forEach((el) => {
    const job = findJobByName(el.name);
    generateSet2(el, job.jobShort, 90);
    generateSet3(el, job.jobShort, 90);
  });
}

function generateSet2(long, short, lvl) {
  let cont = document.createElement("DIV");
  let icon = document.createElement("DIV");
  let par = document.createElement("P");
  icon.id = short + "-icon";
  par.id = short + "-lvl2";
  cont.classList.add("card-job-set2");
  icon.classList.add("use");
  par.classList.add("cardp1", "joblvl");
  // console.log(icon);

  cont.appendChild(icon);
  cont.appendChild(par);
  updateJobText(cont);

  updateUse(cont);

  // resize observer
  const ro = new ResizeObserver(entries => {
    for (let entry of entries) {
      let iconEl = entry.target.children[0];
      iconEl.style.display = 'block';
      if (iconEl.clientWidth <= 30){
        iconEl.style.display = 'none';
        return;
      }
      iconEl.style.borderWidth = iconEl.clientWidth * (3/68) + 'px';
      iconEl.style.borderRadius = iconEl.clientWidth * (10/68) + 'px';
    }
  });
  ro.observe(cont);

  cardJob2.appendChild(cont);
}

function generateSet3(long, short, lvl) {
  let cont = document.createElement("DIV");
  let icon = document.createElement("DIV");
  let par = document.createElement("P");
  icon.id = short + "-icon";
  par.id = short + "-lvl3";
  cont.classList.add("card-job-set3");
  icon.classList.add("use");
  par.classList.add("cardp3", "joblvl");

  cont.appendChild(icon);
  cont.appendChild(par);
  updateJobText(cont);

  console.log(cont);
  updateUse(cont);
  cardJob3.appendChild(cont);
}
